import React, { Fragment, useEffect, useState } from "react";

import ReactDOM from "react-dom";

import logo_main2 from "../../assets/images/logo_main2.png";
import { MobileButtonWrapper, MobileMenuHeader } from "../../styles/sharedStyles";
import { SearchMenu } from "../SearchMenu/SearchMenu";

import {
  BottomBar,
  ButtonContainer,
  Close,
  CustomMButtonWrapper,
  Logo,
  MenuButton,
  MenuContent,
  MenuItem,
  MenuLink,
  MenuLinkCustom,
  MenuList,
  MenuSection,
  MenuWrapper,
  Search,
  SecondButton,
  Separator,
  SocialLink,
  SocialLinks,
  Title,
} from "./styles";

interface MobileMenuProps {
  visible: boolean;
  onClose: () => void;
  isCLevelPage?: boolean;
}

export const MenuMobile: React.FC<MobileMenuProps> = ({
  visible,
  onClose,
  isCLevelPage = false
}) => {
  const [showSearch, setShowSearch] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    if (visible || showSearch) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [visible, showSearch]);

  if (!visible && !showSearch) return null;

  const overlayRoot = document.getElementById("overlay-root");

  if (!overlayRoot) return null;

  return ReactDOM.createPortal(
    <Fragment>
      {visible && (
        <MenuWrapper>
          <MobileMenuHeader>
            <MobileButtonWrapper onClick={() => setShowSearch(true)} >
              <Search />
            </MobileButtonWrapper>
            <Logo src={logo_main2} alt="Logo" />
            <CustomMButtonWrapper onClick={onClose}>
              <Close />
            </CustomMButtonWrapper>
          </MobileMenuHeader>
          <MenuContent>
            <MenuSection>
              <Title>Консалтинг</Title>
              <MenuList>
                <MenuItem>
                  <MenuLink to="/services/c-level" onClick={onClose}>
                    Продвижение ТОП–менеджеров
                  </MenuLink>
                </MenuItem>
                <MenuItem>
                  <MenuLink to="/services/cv-ready" onClick={onClose}>
                    Резюме «Под ключ»
                  </MenuLink>
                </MenuItem>
                <MenuItem>
                  <MenuLink to="/services/talkitout" onClick={onClose}>
                    Сессия «Выговориться»
                  </MenuLink>
                </MenuItem>
                <MenuItem>
                  <MenuLink to="/services/career-consult" onClick={onClose}>
                    Карьерная консультация
                  </MenuLink>
                </MenuItem>
                <MenuItem>
                  <MenuLink to="/services/search-support" onClick={onClose}>
                    Пакетное сопровождение «Хочу оффер»
                  </MenuLink>
                </MenuItem>
                <MenuItem>
                  <MenuLink to="/services/vacancies" onClick={onClose}>
                    Подписка на поиск вакансий
                  </MenuLink>
                </MenuItem>
                <MenuItem>
                  <MenuLink to="/services/linkedin-boost" onClick={onClose}>
                    Развитие Linkedin профиля
                  </MenuLink>
                </MenuItem>
                <MenuItem>
                  <MenuLink to="/services/career-audit" onClick={onClose}>
                    Карьерный аудит 360
                  </MenuLink>
                </MenuItem>
                <MenuItem>
                  <MenuLink to="/services/probation-support" onClick={onClose}>
                    Сопровождение испытательного срока
                  </MenuLink>
                </MenuItem>
                <MenuItem>
                  <MenuLink to="/services/it-training" onClick={onClose}>
                    Обучение профессии ИТ Рекрутер
                  </MenuLink>
                </MenuItem>
              </MenuList>
            </MenuSection>

            <MenuSection>
              <MenuLinkCustom to="/company" onClick={onClose}>
                    О нас
              </MenuLinkCustom>
              <MenuLinkCustom to="/reviews" onClick={onClose}>
                    Отзывы
              </MenuLinkCustom>
              <MenuLinkCustom to="/blog" onClick={onClose}>
                    Блог
              </MenuLinkCustom>
            </MenuSection>

          </MenuContent>
          <BottomBar>
            <ButtonContainer>
              <MenuButton
                $isCLevelPage={isCLevelPage}
                href="https://t.me/ProhorovaConsult"
                target="_blank"
                rel="noopener noreferrer"
              >
                Задать вопрос
              </MenuButton>
              <SecondButton
                href="https://t.me/belaymamba_vacancy"
                target="_blank"
                rel="noopener noreferrer"
              >
                Чат с вакансиями в Telegram
              </SecondButton>
            </ButtonContainer>
            <SocialLinks>
              <SocialLink
                href="https://www.linkedin.com/in/%D0%BB%D1%8E%D0%B1%D0%BE%D0%B2%D1%8C-%D0%BF%D1%80%D0%BE%D1%85%D0%BE%D1%80%D0%BE%D0%B2%D0%B0-755167185/"
                target="_blank"
                rel="noopener noreferrer"
              >LinkedIn</SocialLink>
              <Separator>&#47;</Separator>
              <SocialLink
                href="https://t.me/ProhorovaConsult"
                target="_blank"
                rel="noopener noreferrer"
              >Telegram</SocialLink>
              <Separator>&#47;</Separator>
              <SocialLink
                href="https://www.instagram.com/belaymamba_it?igsh=MWZrajI4NjE0OGFqNQ=="
                target="_blank"
                rel="noopener noreferrer"
              >Instagram</SocialLink>
              <Separator>&#47;</Separator>
              <SocialLink
                href="https://youtube.com/@lubovprohorovacareer?feature=shared"
                target="_blank"
                rel="noopener noreferrer"
              >YouTube</SocialLink>
            </SocialLinks>
          </BottomBar>
        </MenuWrapper>
      )}

      {showSearch && (
        <SearchMenu
          searchQuery={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          onClose={() => setShowSearch(false)}
          visible={showSearch}
        />
      )}
    </Fragment>,
    overlayRoot
  );
};
